// extracted by mini-css-extract-plugin
export default {"spinnerBox":"RegisterStepSpinner_spinnerBox__vPR+3","spinner":"RegisterStepSpinner_spinner__5CE48"};